
const headers = [
  {
    label: 'เลขเอกสาร/เลขร้องทุกข์',
    field: 'complaintCode',
  },
  {
    label: 'ผู้ประกอบการ / ชื่อผู้ร้องทุกข์ / ผู้มอบอำนาจ',
    field: 'companyName',
  },
  {
    label: 'วันที่ยื่นเอกสาร',
    field: 'status',
  },
  {
    label: 'Action',
    field: 'action',
    tdClass: 'text-center',
  },
  ]

  export default headers